import * as React from 'react'
import type { SVGProps } from 'react'
export interface CheckIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * check
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const CheckIcon = (props: CheckIconProps) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m5 12l5 5L20 7"
      />
    </svg>
  )
}
